import { useState } from 'react';

interface VerifyChangeModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (verificationNote: string) => Promise<void>;
}

export function VerifyChangeModal({ open, onClose, onConfirm }: VerifyChangeModalProps) {
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!open) return null;

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!note.trim()) {
      setError('La nota de verificación es obligatoria.');
      return;
    }
    setSaving(true);
    setError(null);
    try {
      await onConfirm(note.trim());
      setNote('');
      onClose();
    } catch {
      setError('No se pudo cerrar la solicitud.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-lg border border-border bg-background p-6 shadow-lg">
        <h2 className="text-lg font-semibold mb-4">Verificar implementación</h2>
        <form className="space-y-4" onSubmit={(e) => void handleSubmit(e)}>
          <label className="block text-sm">
            Nota de verificación
            <textarea
              className="mt-1 w-full rounded-md border border-border px-3 py-2 text-sm min-h-[100px]"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              required
              placeholder="Evidencia de que el cambio se implementó según lo planificado…"
            />
          </label>
          {error && <p className="text-destructive text-sm">{error}</p>}
          <div className="flex justify-end gap-2">
            <button type="button" className="btn btn-outline" onClick={onClose} disabled={saving}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Cerrando…' : 'Cerrar cambio'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
